import { Injectable } from '@angular/core';
import { ResponsiveState } from 'ng2-responsive';

@Injectable()
export class MobileScrollToService {
    constructor(
        private responsiveState: ResponsiveState
    ) {}

    /**
     * Checks if its a mobile device and perform page scroll
     * */
    public scrollTo(element: string): void {
        this.responsiveState.deviceObserver.subscribe((device) => {
            const $ref = document.querySelector(element);
            if (device === 'mobile' && null !== $ref) {
                $ref.scrollIntoView(true);
            }
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/shared/services/mobile-scroll-to.service.ts